import { render, staticRenderFns } from "./card-preferences.vue?vue&type=template&id=7a85fc25&scoped=true"
import script from "./card-preferences.vue?vue&type=script&lang=js"
export * from "./card-preferences.vue?vue&type=script&lang=js"
import style0 from "./card-preferences.vue?vue&type=style&index=0&id=7a85fc25&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a85fc25",
  null
  
)

export default component.exports